import { Alert, Button, Col, Form, Row } from "antd";

import { FormItemInput } from "../../ant-wrapper/form-item";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function MotoristaForm({
  onFinish,
  setError,
  error,
  initialValues = {},
  loading = false,
  viewMode = false,
}) {
  const [form] = Form.useForm();
  const onEdit = () => {
    setError();
  };
  return (
    <>
      {error && (
        <>
          <Alert message={error} type="error" />
          <br />
        </>
      )}
      <Form
        form={form}
        onChange={onEdit}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={initialValues}
      >
        <Row gutter={[8, 8]}>
          <Col span={8}>
            <FormItemInput
              {...formItemLayout}
              name="nome"
              rules={[
                { required: true, message: "Campo não pode ser vazio" },
                { max: 150, message: "Tamanho máximo de 150 caracteres" },
              ]}
              label="Nome"
              viewMode={viewMode}
            />
          </Col>
          <Col span={8}>
            <FormItemInput
              {...formItemLayout}
              name="cnh"
              rules={[{ max: 50, message: "Tamanho máximo de 50 caracteres" }]}
              label="CNH"
              viewMode={viewMode}
            />
          </Col>
          <Col span={3}>
            <FormItemInput
              {...formItemLayout}
              name="categoria_cnh"
              rules={[{ max: 20, message: "Tamanho máximo de 20 caracteres" }]}
              label="Categoria CNH"
              viewMode={viewMode}
            />
          </Col>
        </Row>
        {!viewMode && (
          <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit">
              Enviar
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
}
